import { render, staticRenderFns } from "./PublicOrganizationProfile.vue?vue&type=template&id=6624dcf5&scoped=true&"
import script from "./PublicOrganizationProfile.vue?vue&type=script&lang=js&"
export * from "./PublicOrganizationProfile.vue?vue&type=script&lang=js&"
import style0 from "./PublicOrganizationProfile.vue?vue&type=style&index=0&id=6624dcf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6624dcf5",
  null
  
)

export default component.exports